import React, { Component } from 'react';
import Swiper from 'react-id-swiper/lib/custom';
import { Link } from "react-router-dom";
import { API_URL, IMAGE_URL } from "../../config/Config";
import axios from "axios/index";
// import { ToastContainer, toast } from 'react-toastify';



export default class SameAds extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCatId: 0,
            sortBy: 1,
            items: []
        };
    }
    componentDidMount() {
        this.handleRequest();
    }

    async handleRequest() {
        const { selectedCatId, sortBy } = this.state;
        const data = { "catId": selectedCatId, 'sortby': sortBy };
        // const data = {"catId":13};
        // this.setState({ loading: false });
        try {
            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: data,
                url: `${API_URL}business-by-cat`,
            };
            // let response = await axios.post(`${API_URL}business-by-cat`, data,);
            let response = await axios(options);

            if (response.status < 200 || response.status > 300) {
                const error = new Error(response.statusText);
                error.response = response;
                console.log(error);
                // toast.error('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.', {
                //     autoClose: 3000,
                //     position: toast.POSITION.TOP_RIGHT,
                //     rtl: true
                // });
            } else {
                let merchants = response.data.data;
                this.setState({
                    items: merchants
                });
            }
        } catch (e) {
            let apiError = await e.response;
            if (apiError === undefined) {
                console.log(e);
            } else {
                let statusText = await apiError.statusText;
                console.log(statusText);

            }
        }
        // this.setState({ loading: true });
    };

    mathrating(ratings) {
        const starTotal = 5;
        const starPercentage = (ratings / starTotal) * 100;
        var starPercentageRounded = `${(Math.round(starPercentage / 10) * 10)}%`;
        return starPercentageRounded
    }



    render() {
        const params = {
            slidesPerView: 3,
            spaceBetween: 30,
            // autoplay: {
            //     delay: 1500,
            //     disableOnInteraction: false
            // },
            lazy: true,
            loop: true,
            loopFillGroupWithBlank: true,
            // pagination: {
            //     el: '.swiper-pagination',
            //     clickable: true,
            //     dynamicBullets: true
            // },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                960: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                630: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                425: {
                    slidesPerView: 1,
                    spaceBetween: 20
                }
            },
            activeSlideKey: 'string'

        };

        return (
            <div className="last-ads">
                <Swiper {...params} shouldSwiperUpdate>
                    {this.state.items.map((item, i) => {
                        return (
                            <div key={i} >
                                <div className="wiloke-listgo-listing-item">
                                    <div className="listing__media">
                                        <span className="onfeatued">
                                            <i className="fa fa-star-o"></i>
                                            <span className="special" >ویژه</span>
                                        </span>
                                        <div className="ribbon">
                                            <div className="inner-ribbon">
                                                <span className="r-txt-1">20% تخفیف</span>
                                            </div>
                                        </div>
                                        <Link to={"/merchant/" + item.id} >
                                            <img src={IMAGE_URL + item.cover} alt={item.title} />
                                        </Link>
                                        <div className="listing__cat">
                                            <Link to={"/merchant/" + item.id} >
                                                مهاجرت
                                            </Link>
                                        </div>
                                        <Link to={"/merchant/" + item.id} className="listng-logo-a" >
                                            <img className="listing-logo" src="/assets/images/buss.png" alt="لوگو" />
                                        </Link>
                                    </div>
                                    <div className="listing__body">
                                        <h3 className="listing__title">
                                            <Link to={"/merchant/" + item.id} >
                                                {item.title}
                                            </Link>
                                        </h3>
                                        <div className="listing__content">
                                            <p className="listing-address">
                                                <span className="listing-span">آدرس :</span>
                                                {item.address}
                                            </p>
                                            <p className="listing-address">
                                                <span className="listing-span">تلفن :</span>
                                                {item.phone}
                                            </p>
                                        </div>
                                        <div className="item__actions">
                                            <div className="listgo-go-to-map-btn tb__cell">
                                                <i className="fas fa-map-marker-alt"></i>
                                            </div>
                                            <div className="tb__cell">
                                                <i className="far fa-heart"></i>
                                            </div>
                                            <div className="tb_star">
                                                <div className="stars-outer">
                                                    <div className="stars-inner"
                                                        style={{ width: this.mathrating(item.rating) }}
                                                    >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div >
                        )
                    })}
                </Swiper>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/merchants/sameads.jsx